import { useMutation, useQueryClient } from "@tanstack/react-query";

import { post } from "common/helpers/HTTP";

async function createMasterApiTokenRequest(): Promise<string> {
  return (await post(`customers/master-key`)).master_api_key;
}

export default function useMasterApiTokenMutations() {
  const queryClient = useQueryClient();

  const {
    mutateAsync: createMasterApiToken,
    isPending: isCreatingMasterApiToken,
  } = useMutation({
    mutationFn: () => createMasterApiTokenRequest(),
    onSuccess: (newKey) => {
      queryClient.setQueryData(["masterApiKey"], newKey);
    },
  });

  return {
    createMasterApiToken,
    isCreatingMasterApiToken,
  };
}
